
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import { getHrefLangs } from 'src/core/utils/href-langs';
import Legal, { PageProps } from 'src/components/legal';
import React, { ReactElement } from 'react';
/**
 * `Props` type.
 */

type Props = {
  data: PageProps,
  slug: string
};

/**
 * `FundedProjects` page.
 */

const FundedProjects = (props: Props): ReactElement => (
  <Legal
    {...props}
    hrefLangs={getHrefLangs(props?.data?.translations, 'fundedProjects')}
  />
);


/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  if (['de', 'es', 'fr'].includes(locale)) {
    return {
      notFound: true
    };
  }

  const slug = getApiPageSlugByLocale('fundedProjects', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `FundedProjects` page.
 */

export default FundedProjects;
